export interface SheetResponse {
  columns?: string[]
  data?: Record<string, unknown>[]
  total?: number
  error?: string
  available_sheets?: string[]
}

export const statusColors: Record<string, 'default' | 'warning' | 'success' | 'error'> = {
  draft: 'default',
  calculating: 'warning',
  completed: 'success',
  error: 'error',
}

export const publicatieStatusColors: Record<string, 'default' | 'info' | 'success' | 'warning'> = {
  concept: 'default',
  definitief: 'success',
  archief: 'warning',
}
